import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.75rem;
`;
export default function Menage() {
  return (
    <Wrapper
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M462 393.332H433.332V157.668C433.332 70.7305 362.605 0 275.664 0C188.727 0 118 70.7305 118 157.668V158.789C51.0977 168.543 0 226.297 0 295.332V452C0 485.086 26.9141 512 60 512H216C249.086 512 276 485.086 276 452V295.332C276 226.324 224.934 168.547 158 158.789V157.668C158 92.7852 210.785 40 275.668 40C340.547 40 393.332 92.7852 393.332 157.668V393.336H364.668C337.098 393.336 314.668 415.766 314.668 443.336V492C314.668 503.047 323.621 512 334.668 512H492C503.047 512 512 503.047 512 492V443.332C512 415.762 489.57 393.332 462 393.332ZM236 452C236 463.027 227.027 472 216 472H60C48.9727 472 40 463.027 40 452C40.6172 289.84 38.5898 292.816 41.8672 276.266C95.5742 328.285 180.348 328.359 234.133 276.266C237.41 292.82 235.383 289.852 236 452ZM216.215 236.359C177.008 288.137 99.1953 288.402 59.7852 236.359C77.6875 212.672 106.086 197.332 138 197.332C169.914 197.332 198.312 212.672 216.215 236.359ZM472 472H354.668V443.332C354.668 437.82 359.152 433.332 364.668 433.332H462C467.516 433.332 472 437.82 472 443.332V472ZM118.668 413.332C118.668 424.379 109.715 433.332 98.668 433.332C87.6211 433.332 78.668 424.379 78.668 413.332C78.668 402.285 87.6211 393.332 98.668 393.332C109.711 393.332 118.668 402.289 118.668 413.332ZM197.332 413.332C197.332 424.379 188.379 433.332 177.332 433.332C166.285 433.332 157.332 424.379 157.332 413.332C157.332 402.285 166.285 393.332 177.332 393.332C188.379 393.332 197.332 402.289 197.332 413.332Z"
        className="fill"
      />
    </Wrapper>
  );
}
